export enum LotOfferStatus {
  INACTIVE = "inactive",
  ACTIVE = "active",
  PLANNED = "planned",
  PURCHASE_PENDING = "purchase_pending",
  SOLD = "sold"
}
